import React from 'react'
import './nav.css'
import {BsFillSunFill} from 'react-icons/bs'
import {MdDarkMode} from 'react-icons/md'
import {AiOutlineMenu} from 'react-icons/ai'
import {AiOutlineClose} from 'react-icons/ai'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
import  ESPORTSMANDIR from '../../assets/esports-mandir.png'
import { GrCart } from "react-icons/gr";

const Nav = () => {
  // LIGHT DARK TOGGLE 
  const [activeTheme, setActiveTheme] = useState('#1')
  
  // NAV COLOR TRANSPARENT TO COLOR
  const [navColor, setColor] = useState(false)
  const changeColor = () => {
    if( window.scrollY > 0) {
        setColor(true)
      }else{
        setColor(false)
      }
  }
  window.addEventListener('scroll', changeColor)
  
  
  // const [navUp, setUp] = useState(false)
  // const changeUp = () => {
  //   if( window.scrollY > 0) {
  //       setUp(true)
  //     }else{
  //       setUp(false)
  //     }
  // }
  // window.addEventListener('scroll', changeUp)
  


  return (
    <>
    {/* <div id='navup' className={navUp ? 'active' : ''}> */}
    <nav className={navColor ? 'active' : ''}>
      <div className="container nav_container">
      <Link to = "/"><h4><img src={ESPORTSMANDIR} alt="ESPORTSMANDIR" /></h4></Link>
        <div className='nav_menu'>
          <NavLink to = "/">Home</NavLink>
          <NavLink to = "/about">About</NavLink>
          <NavLink to = "/contact">Contact</NavLink>
          <NavLink to = "/store">Store</NavLink>
          <div className='theme-toggler'>
            <span id='1' onClick={() => setActiveTheme('#1')} className={activeTheme === '#1' ? 'active' : ''}><BsFillSunFill /></span>
            <span id='2' onClick={() => setActiveTheme('#2')} className={activeTheme === '#2' ? 'active' : ''}><MdDarkMode /></span>
          </div>
      <div className="cart-login">
          <button id='login' className='btn btn-primary'>login</button>
        <div className="cart">
          <NavLink to = "/cart"><GrCart /></NavLink>
          </div>
          </div>
        </div>
          <button id='open-menu-btn'><AiOutlineMenu /></button>
          <button id='close-menu-btn'><AiOutlineClose /></button>
      </div>
    </nav>
    {/* </div> */}
    <Outlet />
    </>
  )
}

export default Nav